import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import "./styles/cart.scss";
import Nav from "./Nav";
import {
  TextField,
  Alert,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
const stripePromise = await loadStripe("pk_live_aRr3qYrpVTbyNgBbB7t0jqiy");
// const stripePromise = await loadStripe("pk_test_HGDc5rMpzlE4NJvFygwF1zIW");

export default function Cart() {
  const [total, setTotal] = useState("");
  const [paymentDetails, setPaymentDetails] = useState(false);
  const [payment, setPayment] = useState(false);
  const [tncs, setTncs] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [options, setOptions] = useState({});
  const [discountCode, setDiscountCode] = useState("");
  // const url = "http://localhost:3999";
  const url = "https://dev.pmwwebdesign.com";

  //Alerts
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState(false);
  const [disable, setDisable] = useState(false);
  const [severity, setSeverity] = useState("");

  const handleAlert = (message, severity, duration = 2000) => {
    setDisable(true);
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
    }, duration);
  };

  const handleFormValidation = async () => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phoneRegex = /^[0-9]*$/;

    if (firstName === "" || lastName === "" || phone === "" || email === "") {
      handleAlert("All fields are required", "warning");
    } else if (!email.match(regex)) {
      handleAlert("Email is the wrong format", "warning");
    } else if (!phone.match(phoneRegex)) {
      handleAlert("Please insert your phone with only numbers", "warning");
    } else if (!tncs) {
      handleAlert("You need to accept the T&Cs", "warning");
    } else {
      await createCart();
    }
  };

  const createCart = async () => {
    let reqBody = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
    };

    await axios
      .post(`${url}/property/get-secret`, reqBody)
      .then((res) => {
        setOptions({ clientSecret: res.data.clientSecret });
        setPayment(true);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Could not create your cart - Please try again", "error");
      });

    setPaymentDetails(true);
  };

  return (
    <main className="cart">
      <Nav />
      {!payment ? (
        <section className="form">
          <h2>Please Insert Your Details</h2>
          <section className="form__row">
            <TextField
              id="outlined-basic"
              label="First Name"
              variant="outlined"
              className="field"
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
            <TextField
              id="outlined-basic"
              label="Last Name"
              variant="outlined"
              className="field"
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </section>
          <section className="form__row">
            <TextField
              id="outlined-basic"
              label="Email"
              variant="outlined"
              className="field"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <TextField
              id="outlined-basic"
              label="Phone Number"
              variant="outlined"
              className="field"
              onChange={(e) => setPhone(e.target.value)}
              pattern="[0-9]*"
              required
            />
          </section>
          <FormControlLabel
            control={<Checkbox />}
            label="I confirm I have read and agree to the terms & conditions"
            onChange={() => setTncs(!tncs)}
          />

          {alert ? (
            <Alert severity={severity} width="80%" sx={{ margin: "3% auto" }}>
              {message}
            </Alert>
          ) : null}
          <button onClick={handleFormValidation} disabled={disable}>
            Proceed to payment{" "}
          </button>
        </section>
      ) : (
        <div className="payment-portal">
          <h2 style={{ color: "red" }}>
            Once you have completed payment please wait until you are redirected
            to the Thank You page before leaving
          </h2>
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      )}
    </main>
  );
}
